<template>
  <div>
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label>Social Security Number</label>
          <small v-if="ssnRequired"><span class="redText"> required </span></small>
          <ac-social-security-number v-model="vm.mainModel.ssn">

          </ac-social-security-number>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group enrollment-signup-dob-field">
          <label>DOB
            <small><span class="redText"> required </span></small>
          </label><br/>
          <ac-date-picker v-model="vm.mainModel.birthDate"></ac-date-picker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IdentityInfo",
  props: {
    value: {
      type: [Object],
      required: true,
    },
    ssnRequired: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      vm: {...this.value},
    };
  }
}
</script>

<style scoped>
.enrollment-signup-dob-field {
  width: 100%;
}
.enrollment-signup-dob-field >>> .k-datepicker.k-widget {
  width: 100% !important;
  max-width: 100% !important;
  display: block !important;
  box-sizing: border-box;
}
.enrollment-signup-dob-field >>> .k-datepicker .k-picker-wrap {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
</style>